import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articlesAPI } from '../services/api';

function Home() {
  const [featuredArticles, setFeaturedArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await articlesAPI.getAll();
        if (res.data.success) {
          setFeaturedArticles(res.data.data.slice(0, 3));
        }
      } catch (err) {
        console.error(err);
        // Fallback static articles
        setFeaturedArticles([
          {
            id: 1,
            title: 'Erasmus+ Intercultural Youth Exchange in Siedlce, Poland',
            excerpt: 'A detailed look at the 2024 youth exchange connecting 30 young leaders to discuss environmental issues and sustainability.',
            image_url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80'
          },
          {
            id: 2,
            title: 'European Solidarity Corps: Volunteering Journey',
            excerpt: 'Discover how ESC volunteers from across Europe are contributing to local communities in Siedlce and Krakow.',
            image_url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80'
          },
          {
            id: 3,
            title: 'Raising Awareness for Human Rights and Peace',
            excerpt: 'Our digital campaign reaches thousands, advocating for human dignity, self-determination, and the rule of law.',
            image_url: 'https://images.unsplash.com/photo-1469571486090-7d99c11d50c7?auto=format&fit=crop&w=800&q=80'
          }
        ]);
      }
    };
    fetchArticles();
  }, []);

  const sectionBg01Style = {
    backgroundImage: `url('/assets/img/gallery/section_bg01.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <>
      {/* slider Area Start — height follows banniere image */}
      <div className="slider-area home-hero-banner">
        <div className="slider-active">
          <div className="single-slider slider-height">
            <div className="home-hero-banner__wrap">
              <img src={`${process.env.PUBLIC_URL}/assets/img/gallery/banniere.png`} alt="EFIS — Europe Foundation for International Solidarity" />
              <div className="home-hero-banner__overlay">
                <div className="hero__caption">
                  <h1 data-animation="fadeInUp" data-delay=".6s" style={{ color: '#fff', fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}>Europe Foundation for<br />International Solidarity</h1>
                  <p data-animation="fadeInUp" data-delay=".8s" style={{ color: '#f1f5f9' }}>Promoting international solidarity, intercultural dialogue, and global citizenship through mobility and cooperation programs.</p>
                  <div className="hero__btn">
                    <Link to="/projects" className="btn hero-btn mb-10" data-animation="fadeInLeft" data-delay=".8s">Latest Publications</Link>
                    <Link to="/contact" className="btn white-btn ml-15" style={{ borderRadius: '30px' }} data-animation="fadeInRight" data-delay="1.0s">
                      Join Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="about-low-area section-padding30" style={{background: '#fdfdfd'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="about-caption">
                <div className="section-tittle mb-35">
                  <span>About Our ONG</span>
                  <h2>Welcome to EFIS Poland</h2>
                </div>
                <p style={{fontSize: '16px', lineHeight: '1.8', color: '#4b5563', marginBottom: '20px'}}>
                  Europe Foundation for International Solidarity (Poland) is a non-profit organization dedicated to promoting international solidarity, intercultural dialogue, and global citizenship.
                </p>
                <p style={{fontSize: '16px', lineHeight: '1.8', color: '#4b5563'}}>
                  Established in Siedlce, Poland, the Foundation connects citizens and young people from across Europe and other regions of the world through international mobility and cooperation programs, particularly through the Erasmus+ programme supported by the European Union. These initiatives enable participants to work together around shared values including human rights, peace, equality, and sustainable development.
                </p>
                <div style={{marginTop: '30px'}}>
                  <Link to="/about" className="btn" style={{padding: '12px 30px'}}>Read More About Us</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="about-img" style={{position: 'relative'}}>
                <div className="about-font-img d-none d-lg-block">
                  <img src="/assets/img/gallery/about2.png" alt="EFIS Activities" style={{borderRadius: '8px'}} />
                </div>
                <div className="about-back-img">
                  <img src="/assets/img/gallery/about1.png" alt="Youth Exchange" style={{borderRadius: '8px'}} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section section-padding50 section-compact" style={{background: '#f8fafc', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10">
              <div className="section-tittle text-center mb-80">
                <span>Our Core Purpose</span>
                <h2>Mission & Vision</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="card h-100" style={{border: 'none', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', overflow: 'hidden'}}>
                <div style={{height: '8px', background: 'var(--primary-blue)'}}></div>
                <div className="card-body p-5">
                  <h3 style={{fontWeight: '700', color: 'var(--primary-blue)', marginBottom: '20px'}}>Mission</h3>
                  <p style={{fontSize: '15px', lineHeight: '1.7', color: '#4b5563', marginBottom: '15px'}}>
                    The mission of EFIS is to promote international solidarity and intercultural dialogue by empowering young people and citizens to actively participate in international mobility and cooperation programs.
                  </p>
                  <p style={{fontSize: '15px', lineHeight: '1.7', color: '#4b5563'}}>
                    Through educational, volunteering, and development-oriented initiatives, the Foundation advances human rights, peace, equality, and sustainable development, contributing to more inclusive and just societies.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="card h-100" style={{border: 'none', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', overflow: 'hidden'}}>
                <div style={{height: '8px', background: 'var(--accent-red)'}}></div>
                <div className="card-body p-5">
                  <h3 style={{fontWeight: '700', color: 'var(--accent-red)', marginBottom: '20px'}}>Vision</h3>
                  <p style={{fontSize: '15px', lineHeight: '1.7', color: '#4b5563', marginBottom: '15px'}}>
                    EFIS envisions a more integrated and harmonious global society built on justice, equality, mutual respect, and intercultural understanding.
                  </p>
                  <p style={{fontSize: '15px', lineHeight: '1.7', color: '#4b5563'}}>
                    The Foundation aspires to foster a world where individuals and communities have equal opportunities to participate in shaping their future and contributing to sustainable development grounded in solidarity and shared responsibility.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services/Main Actions Area Start */}
      <div className="service-area section-padding30 section-compact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10">
              <div className="section-tittle text-center mb-80">
                <span>Core Framework</span>
                <h2>Our Main Actions</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 mb-30">
              <div className="single-cat h-100 text-left p-40" style={{border: '1px solid #e2e8f0', borderRadius: '8px', transition: 'all 0.3s', cursor: 'pointer', background: '#fff'}}>
                <div className="cat-cap">
                  <h4 style={{fontWeight: '700', marginBottom: '15px'}}>
                    <Link to="/programs/international-mobility" style={{color: '#2d3748'}}>International Mobility Programs</Link>
                  </h4>
                  <p style={{fontSize: '14px', color: '#4b5563', lineHeight: '1.6'}}>
                    EFIS offers a wide range of international mobility opportunities for young people and citizens, including volunteering, non-formal education, and structured exchange programs. These initiatives allow participants to gain new skills, experience different cultures, and build meaningful relationships with peers from around the world.
                  </p>
                  <p style={{fontSize: '14px', color: '#4b5563', lineHeight: '1.6', marginTop: '10px'}}>
                    Among these opportunities, EFIS participates in the Erasmus+ programme, which enables young people to engage in international exchanges, training, and non-formal learning activities across Europe and in Erasmus+ partner countries, fostering personal growth, intercultural understanding, and professional development.
                  </p>
                  <Link to="/programs/international-mobility" style={{color: 'var(--accent-red)', fontWeight: '600', display: 'inline-block', marginTop: '20px'}}>View Activities →</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-30">
              <div className="single-cat h-100 text-left p-40" style={{border: '1px solid #e2e8f0', borderRadius: '8px', transition: 'all 0.3s', cursor: 'pointer', background: '#fff'}}>
                <div className="cat-cap">
                  <h4 style={{fontWeight: '700', marginBottom: '15px'}}>
                    <Link to="/programs/global-citizenship" style={{color: '#2d3748'}}>Promotion of Global Citizenship</Link>
                  </h4>
                  <p style={{fontSize: '14px', color: '#4b5563', lineHeight: '1.6'}}>
                    The Foundation organizes initiatives that raise awareness of solidarity, human rights, and shared global responsibility, encouraging participants to act as engaged and socially responsible global citizens.
                  </p>
                  <Link to="/programs/global-citizenship" style={{color: 'var(--primary-blue)', fontWeight: '600', display: 'inline-block', marginTop: '20px'}}>View Activities →</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-30">
              <div className="single-cat h-100 text-left p-40" style={{border: '1px solid #e2e8f0', borderRadius: '8px', transition: 'all 0.3s', cursor: 'pointer', background: '#fff'}}>
                <div className="cat-cap">
                  <h4 style={{fontWeight: '700', marginBottom: '15px'}}>
                    <Link to="/programs/cooperation-development" style={{color: '#2d3748'}}>International Cooperation & Development</Link>
                  </h4>
                  <p style={{fontSize: '14px', color: '#4b5563', lineHeight: '1.6'}}>
                    EFIS seeks to develop projects aimed at supporting sustainable development, social inclusion, and reducing social and economic disparities worldwide.
                  </p>
                  <Link to="/programs/cooperation-development" style={{color: 'var(--primary-blue)', fontWeight: '600', display: 'inline-block', marginTop: '20px'}}>View Activities →</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-30">
              <div className="single-cat h-100 text-left p-40" style={{border: '1px solid #e2e8f0', borderRadius: '8px', transition: 'all 0.3s', cursor: 'pointer', background: '#fff'}}>
                <div className="cat-cap">
                  <h4 style={{fontWeight: '700', marginBottom: '15px'}}>
                    <Link to="/programs/youth-empowerment" style={{color: '#2d3748'}}>Youth Empowerment & Capacity Building</Link>
                  </h4>
                  <p style={{fontSize: '14px', color: '#4b5563', lineHeight: '1.6'}}>
                    The Foundation provides workshops, training sessions, and learning opportunities to strengthen leadership, intercultural dialogue, civic engagement, and teamwork skills.
                  </p>
                  <Link to="/programs/youth-empowerment" style={{color: 'var(--accent-red)', fontWeight: '600', display: 'inline-block', marginTop: '20px'}}>View Activities →</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <section className="video-section section-padding30 section-compact" style={{ background: '#fdfdfd', borderTop: '1px solid #e2e8f0' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10">
              <div className="section-tittle text-center mb-50">
                <span>Watch Our Story</span>
                <h2>EFIS in Action</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="video-container" style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                <video 
                  controls 
                  poster="/assets/img/video/video.png" 
                  style={{ width: '100%', display: 'block' }}
                >
                  <source src="/assets/img/video/ae9aa4bd-448b-4902-a1cf-11f8ddc438fd.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Publications Start */}
      <div className="our-cases-area section-padding30 section-compact" style={{background: '#f8fafc', borderTop: '1px solid #e2e8f0'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10 col-sm-10">
              <div className="section-tittle text-center mb-80">
                <span>Our Publications</span>
                <h2>Latest Articles & News</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {featuredArticles.map((article) => (
              <div key={article.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="single-cases" style={{boxShadow: '0 10px 30px rgba(0,0,0,0.03)', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0', background: '#fff', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                  <div className="cases-img" style={{height: '200px', overflow: 'hidden'}}>
                    <img 
                      src={article.image_url || "/assets/img/gallery/case1.png"} 
                      alt={article.title} 
                      style={{width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s'}}
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.06)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  </div>
                  <div className="cases-caption p-4" style={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                    <div>
                      <h3 style={{fontSize: '18px', fontWeight: '700', lineHeight: '1.4', marginBottom: '10px', height: '50px', overflow: 'hidden'}}>
                        <Link to={`/articles/${article.id}`} style={{color: '#1e293b'}}>{article.title}</Link>
                      </h3>
                      <p style={{fontSize: '14px', color: '#64748b', lineHeight: '1.6', height: '70px', overflow: 'hidden', marginBottom: '20px'}}>
                        {article.excerpt}
                      </p>
                    </div>
                    <div>
                      <Link to={`/articles/${article.id}`} className="btn w-100" style={{textAlign: 'center', padding: '10px 20px', fontSize: '14px'}}>Read Article →</Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Want To work */}
      <section className="wantToWork-area">
        <div className="container">
          <div className="wants-wrapper w-padding2 section-bg" style={sectionBg01Style}>
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-7 col-lg-9 col-md-8">
                <div className="wantToWork-caption wantToWork-caption2">
                  <h2>Let's Change The World With Solidarity & Humanity</h2>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4">
                <Link to="/contact" className="btn white-btn f-right sm-left" style={{ borderRadius: '30px' }}>Become A Volunteer</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;